import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { stringify } from 'qs'
import { CmsBlogArticle } from 'types/cms/collection-types'

/**
 * Get the blog article by the given slug from the CMS
 *
 * @param {string} slug
 * @param {Language} locale
 * @returns {Promise<CmsBlogArticle | undefined>}
 */
const getBlogArticleBySlug = async (slug: string, locale: Language = Language.DUTCH): Promise<CmsBlogArticle | undefined> => {
  try {
    const query = stringify({
      locale
    })

    const { data } = await axios.get<CMSApiResponseBody<CmsBlogArticle>>(`${process.env.CMS_API_URL}/blog-article/${slug}?${query}`)

    return data.data
  } catch (_) {
    return undefined
  }
}

export default getBlogArticleBySlug
